import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import m from "./components/CustomTable.js";
import l from "./components/BasicTable.js";
import { TableProvider as i } from "./Context/Table.js";
import s from "./components/DataRow/DataRow.js";
import f from "./components/DataCell/DataCell.js";
import d from "./components/HeaderCell/HeaderCell.js";
import p from "./components/TableHeader/TableHeader.js";
const r = (o) => {
  const { children: t, ...a } = o;
  return t ? /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsx(m, { ...o }) }) : /* @__PURE__ */ e.jsx(l, { ...a });
};
r.Row = s;
r.Cell = f;
r.HeaderCell = d;
r.TableHeader = p;
export {
  r as default
};
//# sourceMappingURL=Table.js.map
